import { gql } from '@apollo/client/core';

export default gql`
  query OgDoubleMaterialityLayout {
    getOrCreateDoubleMateriality {
      _id
    }
  }
`;
